import type {TopicScoreMap} from './buildProgressScoreMap';

export function calculateTotalScoreFromMap(topicScores: TopicScoreMap): number {
  const values = Object.values(topicScores);
  if (values.length === 0) {
    return 0;
  }

  const sum = values.reduce((acc, value) => acc + value.score, 0);
  return sum / values.length;
}
